// @ts-nocheck
import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { Cart } from "@insite/client-framework/Services/CartService";
import { ProductRecommendationOrderModel } from "@insite/client-framework/Services/ProductRecommendationsService";
import {
    chain,
    PrepareData,
} from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/PrepareOrder";
import { generateGeneralPrepare } from "@insite/client-framework/Store/Components/ProductRecommendations/ProductRecommendationsSelector";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";

type HandlerType = Handler<{ cart: Cart }, { recommendation: ProductRecommendationOrderModel }>;

const PrepareDataWithBreakAndPriceFactor: HandlerType = async props => {
    const {
        getState,
        parameter: { cart },
    } = props;

    const session = getSession(getState());
    const currency = session?.currency?.currencyCode || "";

    const { getUnitPrice } = await import(
        /* webpackChunkName: "pricingUtils" */ "@store/Framework/Common/Utilities/pricingUtils"
    );

    const cartItems =
        cart.cartLines?.map(o => ({
            refCode: o.erpNumber,
            qty: o.qtyOrdered,
            price: getUnitPrice(o.pricing, o.qtyOrdered ?? 0).toNumber(),
        })) || [];

    props.recommendation = {
        type: "order",
        order: {
            orderNo: cart.erpOrderNumber || cart.orderNumber,
            items: cartItems,
            shipping: cart.shippingAndHandling,
            total: cart.orderGrandTotal,
            subtotal: cart.orderSubTotal,
            currency,
        },
        ...generateGeneralPrepare(getState()),
    };
};

replaceInChain(chain, PrepareData, PrepareDataWithBreakAndPriceFactor);
